export const SURVEY_REPORT_PROBLEM = 'survey_report_problem' as const;

export interface ReportProblemCaptureMeta {
  projectId: string;
  orgId?: string;
  insightId?: string;
  responderName?: string;
}

export interface ReportProblemContext {
  messageId?: string;
  questionId?: string;
}

export function buildReportProblemCapturePayload(
  description: string,
  context: ReportProblemContext,
  meta: ReportProblemCaptureMeta
) {
  return {
    description,
    questionId: context.questionId,
    messageId: context.messageId,
    projectId: meta.projectId,
    orgId: meta.orgId,
    insightId: meta.insightId,
    responderName: meta.responderName,
  };
}

export function buildReportProblemInput(
  description: string,
  context: ReportProblemContext,
  meta: ReportProblemCaptureMeta
) {
  return {
    projectId: meta.projectId,
    insightId: meta.insightId ?? null,
    questionId: context.questionId ?? null,
    description,
    pageUrl: typeof window === 'undefined' ? null : window.location.href,
  };
}
